module.exports = __webpack_public_path__ + "img/small-book.9f40612d.jpg";